import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HasPermDirective } from './directives/has-perm.directive';
import { PermFormDirective } from './directives/perm-form.directive';
import { PermSelectDirective } from './directives/perm-select.directive';

/**
 * Лёгкий модуль ТОЛЬКО с директивой `*hasPerm` — без регистрации стора/эффектов.
 * Импортируется в любые feature-модули, где нужна `*hasPerm` в шаблонах.
 * (Стор/эффекты слайса access регистрируются один раз — в AccessModule из AppModule.)
 */
@NgModule({
  declarations: [HasPermDirective, PermFormDirective, PermSelectDirective],
  imports: [CommonModule],
  exports: [HasPermDirective, PermFormDirective, PermSelectDirective],
})
export class AccessUiModule {}
